import { TaxType, TicketSaleStatus } from '@wix/events-types';
import { WIX_FEE_RATE } from '../constants/event';
import { getFormattedMoney } from '../price/formatter';
import { getPreliminaryTax, isFeeAdded, isTaxAdded } from './checkout';
export var calculateTicketPriceBreakDown = function (ticketPrice, feeType, taxConfig) {
    var currency = ticketPrice.currency;
    var feeAdded = isFeeAdded(feeType);
    var taxIncluded = (taxConfig === null || taxConfig === void 0 ? void 0 : taxConfig.type) === TaxType.INCLUDED;
    var originalTicketPrice = Number(ticketPrice.amount || 0);
    var ticketPriceAmount = originalTicketPrice;
    var tax = getPreliminaryTax(taxConfig, ticketPriceAmount, currency);
    var taxAmount = getTaxAmount(tax);
    ticketPriceAmount = ticketPriceAfterTax(ticketPriceAmount, tax);
    var feeAmount = Number((ticketPriceAmount * WIX_FEE_RATE).toFixed(2));
    var totalBuyerPaysAmount = feeAdded ? ticketPriceAmount + feeAmount : ticketPriceAmount;
    var getPaidAmount = feeAdded ? ticketPriceAmount : totalBuyerPaysAmount - feeAmount;
    var totalBuyerPays = getFormattedMoney({ amount: totalBuyerPaysAmount.toString(), currency: currency });
    var getPaid = getFormattedMoney({ amount: getPaidAmount.toString(), currency: currency });
    var fee = getFormattedMoney({ amount: feeAmount.toString(), currency: currency });
    var taxFormatted = tax ? getFormattedMoney(tax.amount) : null;
    var formattedTicketPrice = getFormattedMoney(taxIncluded ? { amount: (originalTicketPrice - taxAmount).toString(), currency: currency } : ticketPrice);
    return {
        totalBuyerPays: totalBuyerPays,
        fee: fee,
        getPaid: getPaid,
        ticketPrice: formattedTicketPrice,
        tax: taxFormatted,
    };
};
export var getTicketServiceFee = function (ticket, taxConfig) {
    var ticketPrice = Number(ticket.price.amount);
    var tax = getPreliminaryTax(taxConfig, ticketPrice, ticket.price.currency);
    var ticketPriceAmount = ticketPriceAfterTax(ticketPrice, tax);
    return getFormattedMoney({
        amount: (ticketPriceAmount * WIX_FEE_RATE).toString(),
        currency: ticket.price.currency,
    });
};
export var getTicketTax = function (ticket, taxConfig) {
    return getFormattedMoney(getPreliminaryTax(taxConfig, Number(ticket.price.amount), ticket.price.currency).amount);
};
var getTaxAmount = function (tax) { var _a, _b; return Number((_b = (_a = tax === null || tax === void 0 ? void 0 : tax.amount) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : 0); };
var ticketPriceAfterTax = function (ticketPrice, tax) {
    return ticketPrice + (isTaxAdded(tax === null || tax === void 0 ? void 0 : tax.type) ? getTaxAmount(tax) : 0);
};
export var getHideNotOnSale = function (ticket) { var _a, _b; return (_b = (_a = ticket.salePeriod) === null || _a === void 0 ? void 0 : _a.hideNotOnSale) !== null && _b !== void 0 ? _b : null; };
export var shouldTicketLimitTooltipShow = function (availableTicketsQuantity, selectedQuantity) {
    return availableTicketsQuantity === 0 && !!selectedQuantity;
};
export var saleScheduled = function (ticket) {
    return ticket.saleStatus === TicketSaleStatus.SALE_SCHEDULED;
};
export var saleStarted = function (ticket) {
    return ticket.saleStatus === TicketSaleStatus.SALE_STARTED;
};
export var saleEnded = function (ticket) {
    return ticket.saleStatus === TicketSaleStatus.SALE_ENDED;
};
export var shouldShowSaleEndsLabel = function (ticket) {
    return saleStarted(ticket) && !!ticket.limitPerCheckout && ticket.salePeriod;
};
export var saleStartedAndHasTickets = function (ticket) {
    return saleStarted(ticket) && !!ticket.limitPerCheckout;
};
export var saleEndedAndHasTickets = function (ticket) {
    return saleEnded(ticket) && !!ticket.limitPerCheckout;
};
export var saleScheduledAndHasTickets = function (ticket) {
    return saleScheduled(ticket) && !!ticket.limitPerCheckout;
};
//# sourceMappingURL=ticket.js.map